<script>
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import CannedResponseAssetAPI from 'dashboard/api/cannedResponseAsset';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { buildMarkdownFromAsset } from 'dashboard/helper/cannedResponseAssetHelper';

export default {
  name: 'CannedResponseAssetUploader',
  components: {
    NextButton,
  },
  data() {
    return {
      uploadedAssets: [],
      isUploading: false,
    };
  },
  methods: {
    openPicker() {
      this.$refs.assetInput?.click();
    },
    async uploadSelectedFiles(event) {
      const files = Array.from(event?.target?.files || []);
      if (!files.length) return;

      this.isUploading = true;

      try {
        const formData = new FormData();
        files.forEach(file => formData.append('attachments[]', file));

        const response = await CannedResponseAssetAPI.create(formData);
        const assets = response?.data?.assets || [];

        this.uploadedAssets = [...assets, ...this.uploadedAssets];
        useAlert(
          this.$t('CANNED_MGMT.ASSET_UPLOADER.API.UPLOAD_SUCCESS', {
            count: assets.length,
          })
        );
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error ||
          this.$t('CANNED_MGMT.ASSET_UPLOADER.API.UPLOAD_ERROR');
        useAlert(errorMessage);
      } finally {
        this.isUploading = false;
        event.target.value = '';
      }
    },
    async copyMarkdown(asset) {
      try {
        const markdown = asset.markdown || buildMarkdownFromAsset(asset);
        await copyTextToClipboard(markdown);
        useAlert(this.$t('CANNED_MGMT.ASSET_UPLOADER.API.COPY_SUCCESS'));
      } catch (error) {
        useAlert(this.$t('CANNED_MGMT.ASSET_UPLOADER.API.COPY_ERROR'));
      }
    },
  },
};
</script>

<template>
  <div class="w-full py-2">
    <div class="flex items-center gap-2 pb-2">
      <NextButton
        icon="i-lucide-image-plus"
        :label="$t('CANNED_MGMT.ASSET_UPLOADER.UPLOAD_BUTTON')"
        :is-loading="isUploading"
        :disabled="isUploading"
        slate
        faded
        sm
        @click.prevent="openPicker"
      />
      <span class="text-xs text-n-slate-11">
        {{ $t('CANNED_MGMT.ASSET_UPLOADER.HINT') }}
      </span>
    </div>

    <input
      ref="assetInput"
      type="file"
      accept="image/*"
      multiple
      hidden
      @change="uploadSelectedFiles"
    />

    <div v-if="uploadedAssets.length" class="max-h-48 overflow-auto space-y-2">
      <div
        v-for="asset in uploadedAssets"
        :key="asset.id || asset.public_url"
        class="flex items-center justify-between gap-2 rounded border border-n-weak px-2 py-1"
      >
        <div class="min-w-0 flex-1">
          <p class="truncate text-sm text-n-slate-12">{{ asset.file_name }}</p>
          <p class="truncate text-xs text-n-slate-11">{{ asset.public_url }}</p>
        </div>
        <NextButton
          :label="$t('CANNED_MGMT.ASSET_UPLOADER.COPY_BUTTON')"
          slate
          faded
          xs
          @click.prevent="copyMarkdown(asset)"
        />
      </div>
    </div>
  </div>
</template>
